module.exports = __webpack_public_path__ + "img/img-98.07cf5731.png";